import moment from "moment-timezone"
import HubSpot from "./HubSpot"
import api from "./api"
import qs from "query-string"
import replace from "./replace"
import { format } from "date-fns"
import submitToMailChimp from "./submitToMailChimp"

const submitBookTour = async ({
  user: { name, email, phone, message },
  locationsUuid,
  space,
  contextDate,
  contextTime,
  calendar,
  marketingEmails = false,
}) => {
  const searchParams = qs.parse(
    typeof window !== "undefined" ? window.location.search : ""
  )

  let move_in_date = null
  if (searchParams.move_in_date) {
    if (moment(searchParams.move_in_date, "YYYY-MM-DD", true).isValid()) {
      move_in_date = moment(searchParams.move_in_date, "YYYY-MM-DD").format(
        "YYYY-MM-DD"
      )
    } else {
      move_in_date = moment().format("YYYY-MM-DD")
    }
  }

  const payload = {
    space_id: locationsUuid || space.id || "",
    user_id: space.user ? space.user.id : "",
    calendar_type: calendar.calendar_type,
    calendar_id: calendar.calendar_id,
    name,
    email,
    // company,
    date: moment(contextDate).format("YYYY-MM-DD"),
    time: contextTime,
    message,
    time_zone: calendar.time_zone,
    subject: `${space.contact_name} calls ${name} on ${moment(
      moment(contextDate).format("YYYY-MM-DD") + " " + contextTime,
      "YYYY-MM-DD HH:mm a"
    ).format("MMMM D, LT")}`,
    location: `${space.space_name || space.title} - ${
      space.office_address ? space.office_address.short_address : ""
    }`,
    htmlBody: `<h1>Call details</h1>
<p style="font-size: large">${moment(
      moment(contextDate).format("YYYY-MM-DD") + " " + contextTime,
      "YYYY-MM-DD HH:mm a"
    ).format("MMMM D, YYYY [at] H:mm A")}
<br>${space.office_address ? space.office_address.short_address : "N/A"}</p>

${space.monthly_tour_email_intro}

<h3>User details</h3>

<ul>
<li>Name: ${name}</li>
<li>Phone: ${phone}</li>
<li>Email: ${email}</li>
<li>Message: ${message || "N/A"}</li>
<li>Team Size: ${searchParams.team_size || "N/A"}</li>
<li>Move-in Date: ${move_in_date || "N/A"}</li>
<li>Space Type: ${searchParams.space_type || "N/A"}</li>
<li>Space Profile: <a href="${
      typeof window !== "undefined" ? window.location.href : ""
    }">${replace(space.space_name)}</a></li>
</ul>
${space.monthly_tour_email_footer}`,
    hubSpotAccount: "workplaceone",
    price: searchParams.price_min || 0,
    team_size: searchParams.team_size || "N/A",
    is_team_size_set: typeof searchParams.team_size !== "undefined",
    space_type: searchParams.space_type || "N/A",
    move_in_date,
  }

  // creating the calendar invite only if production
  await api(`sp/book-tour`, {
    payload,
  })
    .then((result) => {
      // do nothing
    })
    .catch((e) => {
      console.log(e)
    })

  const data = {
    fullname: name,
    email,
    phone,
    message: message || "N/A",
    tour_date: contextDate,
    tour_time: contextTime,
    team_size: searchParams.move_in_date || "N/A",
    space_type: searchParams.space_type || "N/A",
    move_in_date: move_in_date || "N/A",
    website: typeof window !== "undefined" ? window.location.href : "",
  }

  const from =
    space.contact_email && space.space_name
      ? `${space.space_name} <${space.contact_email}>`
      : process.env.GATSBY_DEFAULT_EMAIL_ADDRESS

  const formData = {
    email,
    from,
    toEmail:
      space.monthly_tour_confirmation_recipients_emails ||
      process.env.GATSBY_DEFAULT_EMAIL_ADDRESS,
    formData: [
      { label: "Name", value: name },
      { label: "Phone number", value: phone },
      { label: "Email", value: email },
      { label: "Message", value: message || "N/A" },
      { label: "Call Date", value: format(contextDate, "yyyy-MM-dd") },
      { label: "Call Time", value: contextTime },
      { label: "Team Size", value: searchParams.team_size || "N/A" },
      { label: "Searched Move-in Date", value: move_in_date || "N/A" },
      { label: "Space type", value: searchParams.space_type || "N/A" },
    ],
  }

  await HubSpot(
    locationsUuid === "74d90e2e-ab4b-414f-97d2-3c57f2cc422a"
      ? "b933412a-e5ef-49f0-ba02-7a365693cfe5"
      : "2c0f3c19-91d2-47d0-aef2-38468d15e135",
    data,
    formData
  )

  await submitToMailChimp(marketingEmails, name, email)

  return true
}

export default submitBookTour
